<template>

    <div class="fix-item">

        <v-row>

            <v-col class="py-0" cols="12">

                <v-card class="fixture-card mb-2" flat max-width="900">
                    <v-card-text class="fixture-card py-0 px-3">
                        <v-row class="py-0">

                            <v-col class="fixture-title-row py-2 text-center text-sm-left" :class="{'fixture-title-row-xs': $vuetify.breakpoint.xs}" cols="12" sm="7">

                                <h3 :class="{'smaller-text': $vuetify.breakpoint.lg}">{{ game.home_team }} {{ goals }} {{ game.away_team }}</h3>
                                <h5>{{ koDateTime }}</h5>
                                <p class="d-block d-sm-none mb-0" v-if="hasPredicted">Result: {{ res }}, Score: {{ scr }}</p>
                                <div class="d-block d-sm-none" v-if="!gameStarted">
                                  <predict-modal :game="game" :size="'block'" :edit="hasPredicted" />
                                </div>
                                <v-btn class="d-block d-sm-none mt-1" color="secondary" block outlined disabled v-if="!hasPredicted && gameStarted">Did not predict</v-btn>
                                
                            </v-col>

                            <v-col class="fixture-btn-col ma-0 pa-0 pr-4 d-none d-sm-block" cols="12" sm="5">
                                <v-row class="py-0">

                                  <!-- GAME NOT STARTED, NOT PREDICTED -->
                                  <v-col cols="12" v-if="!gameStarted && !hasPredicted">
                                    <predict-modal :game="game" :size="'block'"/>
                                  </v-col>

                                  <!-- GAME NOT STARTED, HAS PREDICTED -->
                                  <v-col class="ma-0 pa-0 px-3" cols="12" v-if="hasPredicted">
                                    <v-row>
                                      <v-col class="py-0 mt-2" cols="5">
                                        <v-row>
                                          <v-col class="py-0" cols="12">Res: {{ res }}</v-col>
                                        </v-row>
                                        <v-row>
                                          <v-col class="py-0" cols="12">Scr: {{ scr }}</v-col>
                                        </v-row>
                                      </v-col>
                                      <v-col class="py-0 mt-2" cols="7">
                                        <predict-modal :game="game" :size="'block'" :edit="true" v-if="!gameStarted" />
                                      </v-col>
                                    </v-row>
                                  </v-col>

                                  <!-- GAME STARTED, NOT PREDICTED -->
                                  <v-col cols="12" v-if="gameStarted && !hasPredicted">
                                    <v-btn color="secondary" block outlined disabled>Did not predict</v-btn>
                                  </v-col>

                                </v-row>
                            </v-col>

                        </v-row>
                    </v-card-text>
                </v-card>

            </v-col>
        </v-row>

    </div>

</template>

<script>
  import moment from 'moment-timezone';
  import PredictModal from "./predictModal";

  export default {
    name: "FixtureItem",
    components: {PredictModal},
    props: [
      'game',
      'index',
      'games'
    ],
    computed: {
      goals() {
        return this.game.predictions.length ? ' ' + this.game.predictions[0].home_goals + ' - ' + this.game.predictions[0].away_goals + ' ' : ' vs ';
      },
      res() {
        return this.game.predictions.length ? this.game.predictions[0].result_points : '';
      },
      scr() {
        return this.game.predictions.length ? this.game.predictions[0].score_points : '';
      },
      koDateTime() {
        return moment(this.game.kickoff_datetime).format('ddd DD MMM YYYY - HH:mm').toUpperCase();
      },
      koDate() {
        return moment(this.game.kickoff_datetime).format('ddd DD MMM YYYY')
      },
      prevKoDate() {
        if (this.index != 0) {
          return moment(this.games[this.index - 1].kickoff_datetime).format('ddd DD MMM YYYY')
        }
        return null;
      },
      koTime() {
        return moment(this.game.kickoff_datetime).format('HH:mm')
      },
      prevKoTime() {
        if (this.index != 0) {
          return moment(this.games[this.index - 1].kickoff_datetime).format('HH:mm')
        }
        return null;
      },
      gameStarted() {
        return moment() > moment.tz(this.game.kickoff_datetime, 'Europe/London');
      },
      homeAbbrv() {
        return this.game.home_abbrv ? this.game.home_abbrv.abbrv : '??';
      },
      awayAbbrv() {
        return this.game.away_abbrv ? this.game.away_abbrv.abbrv : '??';
      },
      abbrvPred() {
        return this.homeAbbrv + ' ' + this.game.predictions[0].home_goals + ' - ' + this.game.predictions[0].away_goals + ' ' + this.awayAbbrv;
      },
      hasPredicted() {
        return !!this.game.predictions.length;
      },
      predCols() {
        if (!this.gameStarted || this.$vuetify.breakpoint.name !== 'xs') {
          return 5;
        }
        return 6;
      },
      pointsCols() {
        if (!this.gameStarted || this.$vuetify.breakpoint.name !== 'xs') {
          return 5;
        }
        return 6;
      },
      size () {
        const size = {xs:'small',sm:'small',lg:'large',xl:'x-large'}[this.$vuetify.breakpoint.name];
        return size ? { [size]: true } : {}
      },
      btnColor() {
        return this.game.predictions.length ? 'success' : 'secondary';
      },
      btnMsg() {
        return this.game.predictions.length ? 'Edit' : 'Predict Now';
      }
    },
    methods: {
      //
    },
    created() {
      
    }
  }
</script>

<style scoped>

    .fixture-card {
        background: var(--v-primary-base);
    }

    .fixture-title-row {
        background: var(--v-primary-base);
        border-bottom: 1px solid #ddd;
    }

    .fixture-title-row-xs {
        border-bottom: 1px solid #ddd;
    }

    .fixture-btn-col {
        border-bottom: 1px solid #ddd;
    }

    .thing {
      border: 1px solid black;
    }

    .thong {
      border: 1px solid yellow;
    }

    .smaller-text {
      font-size: 0.85rem;
    }

</style>
